var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 129"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0E0FD",
    d: "M143.11 13.852H7.534a6.67 6.67 0 0 0-6.67 6.675V96.29c0 1.77.703 3.469 1.954 4.72l26.014 26.035A6.67 6.67 0 0 0 33.548 129H143.11a6.67 6.67 0 0 0 6.67-6.675V20.527a6.67 6.67 0 0 0-6.67-6.675"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#224BBE",
    d: "M143.16 14.718H7.484c-3.655 0-6.618 2.947-6.618 6.58v14.199h148.913V21.298c0-3.633-2.964-6.58-6.619-6.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    fillRule: "nonzero",
    d: "M102.374 14.717h-5.07C97.305 6.58 104.023 0 112.288 0s14.981 6.58 14.981 14.717c0 8.139-6.716 14.72-14.981 14.72h-4.945V24.39h4.945c5.484 0 9.913-4.34 9.913-9.673 0-5.332-4.43-9.67-9.913-9.67s-9.913 4.339-9.913 9.67m-37.382 0h-5.07C59.923 6.58 66.64 0 74.906 0c8.265 0 14.981 6.58 14.981 14.717s-6.716 14.72-14.981 14.72H69.96V24.39h4.945c5.483 0 9.913-4.34 9.913-9.673 0-5.331-4.43-9.67-9.913-9.67s-9.913 4.338-9.913 9.67m-27.5 14.72V24.39c5.484 0 9.913-4.34 9.913-9.673 0-5.332-4.43-9.67-9.913-9.67s-9.913 4.339-9.913 9.67H22.51C22.51 6.581 29.227 0 37.492 0s14.982 6.58 14.982 14.717c0 8.139-6.716 14.72-14.982 14.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M27.688 64.933H13.869a2.614 2.614 0 0 1-2.614-2.614V48.5a2.614 2.614 0 0 1 2.614-2.614h13.819a2.614 2.614 0 0 1 2.614 2.614V62.32a2.614 2.614 0 0 1-2.614 2.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m15.67 51.692-3.55 3.694 6.51 6.084 9.94-9.293-3.55-3.694-6.39 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M54.527 64.933H40.708a2.614 2.614 0 0 1-2.614-2.614V48.5a2.614 2.614 0 0 1 2.614-2.614h13.819A2.614 2.614 0 0 1 57.14 48.5V62.32a2.614 2.614 0 0 1-2.614 2.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m42.51 51.693-3.55 3.693 6.508 6.084 9.941-9.293-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M82.231 64.933H68.413a2.614 2.614 0 0 1-2.614-2.614V48.5a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.615 2.614V62.32a2.614 2.614 0 0 1-2.615 2.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m70.214 51.692-3.55 3.694 6.509 6.084 9.941-9.293-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M109.07 64.933H95.252a2.614 2.614 0 0 1-2.614-2.614V48.5a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.615 2.614V62.32a2.614 2.614 0 0 1-2.615 2.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m97.053 51.692-3.55 3.694 6.509 6.084 9.941-9.293-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M135.91 64.933h-13.82a2.614 2.614 0 0 1-2.613-2.614V48.5a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.614 2.614V62.32a2.614 2.614 0 0 1-2.614 2.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m124.758 51.693-3.55 3.693 6.508 6.084 9.942-9.293-3.55-3.694-6.392 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M27.688 91.772H13.869a2.614 2.614 0 0 1-2.614-2.615V75.34a2.614 2.614 0 0 1 2.614-2.614h13.819a2.614 2.614 0 0 1 2.614 2.614v13.818a2.614 2.614 0 0 1-2.614 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m15.67 78.531-3.55 3.694 6.51 6.084 9.94-9.293-3.55-3.694-6.39 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M54.527 91.772H40.708a2.614 2.614 0 0 1-2.614-2.615V75.34a2.614 2.614 0 0 1 2.614-2.614h13.819a2.614 2.614 0 0 1 2.614 2.614v13.818a2.614 2.614 0 0 1-2.614 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m42.51 78.532-3.55 3.693 6.508 6.084 9.941-9.293-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M82.231 91.772H68.413a2.614 2.614 0 0 1-2.614-2.615V75.34a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.615 2.614v13.818a2.614 2.614 0 0 1-2.615 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m70.214 78.531-3.55 3.694 6.509 6.084 9.941-9.293-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M109.07 91.772H95.252a2.614 2.614 0 0 1-2.614-2.615V75.34a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.615 2.614v13.818a2.614 2.614 0 0 1-2.615 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m97.053 78.531-3.55 3.694 6.509 6.084 9.941-9.293-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M135.91 91.772h-13.82a2.614 2.614 0 0 1-2.613-2.615V75.34a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.614 2.614v13.818a2.614 2.614 0 0 1-2.614 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m124.758 78.532-3.55 3.693 6.508 6.084 9.942-9.293-3.55-3.694-6.392 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M54.527 118.61H40.708a2.614 2.614 0 0 1-2.614-2.614v-13.818a2.614 2.614 0 0 1 2.614-2.614h13.819a2.614 2.614 0 0 1 2.614 2.614v13.818a2.614 2.614 0 0 1-2.614 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m42.51 106.236-3.55 3.694 6.508 6.083 9.941-9.292-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M82.231 118.61H68.413a2.614 2.614 0 0 1-2.614-2.614v-13.818a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.615 2.614v13.818a2.614 2.614 0 0 1-2.615 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m70.214 106.236-3.55 3.694 6.509 6.083 9.941-9.292-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M109.07 118.61H95.252a2.614 2.614 0 0 1-2.614-2.614v-13.818a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.615 2.614v13.818a2.614 2.614 0 0 1-2.615 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m97.053 106.236-3.55 3.694 6.509 6.083 9.941-9.292-3.55-3.694-6.391 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M135.91 118.61h-13.82a2.614 2.614 0 0 1-2.613-2.614v-13.818a2.614 2.614 0 0 1 2.614-2.614h13.818a2.614 2.614 0 0 1 2.614 2.614v13.818a2.614 2.614 0 0 1-2.614 2.615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    fillRule: "nonzero",
    d: "m124.758 106.236-3.55 3.694 6.508 6.083 9.942-9.292-3.55-3.694-6.392 5.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5586F8",
    d: "M0 99.564h26.28c2.222 0 4.022 1.749 4.022 3.907V129z"
  }))));
};
export default SvgCalendar;